<template>
	<v-app>
		<div @mouseover="showDrawer" @mouseleave="hideDrawer">
			<v-navigation-drawer v-model="drawer" app floating :width="navbar" class="nav-shadow" :class="{'nav--isCollapsed': (navbar === 70)}">
				<v-list style="background: rgba(0,0,0,0.2); margin-bottom: 1rem;">
					<v-list-item class="v-list-item-logo" active-class="opacity-1" @click="goDashboard()">
						<v-list-item-action class="v-app-logo" style="opacity: 1;filter: brightness(0) invert(1);">
							<img width="80%" class="mx-auto maxicon" :src="require('/public/img/ic-logo.png')">
							<img width="100%" class="minicon" :src="require('/public/img/ic-logo.png')">
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>
								<div class="pt-1 cl-white font-size-10 font-weight-500 text-capitalize">
									Virtual Office
								</div>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<template v-if="arrMenu.length > 0">
					<v-list dense class="pt-0 cus-m-navbar navbar-custom-view">
						<template v-for="(menu, idm) in arrMenu">
							<template v-if="menu.children.length == 0">
								<v-list-item :key="idm" link router :to="`${menu.path}`" color="cl-primary-light" class="no-drop" :class="(activeMenu.includes(menu.title)) ? 'is-activemenu' : ''" @click="setActiveMenu(menu.path)">
									<v-list-item-icon>
										<v-icon>{{ menu.icon }}</v-icon>
									</v-list-item-icon>

									<v-list-item-title>{{ menu.title }}</v-list-item-title>
								</v-list-item>
							</template>

							<template v-else>
								<v-list-group
									:value="(activeMenu.includes(menu.title)) ? true : false"
									:prepend-icon="menu.icon"
									:key="idm"
									color="cl-primary-light" 
									class="v-list-group__items expand-transition-leave-active expand-transition-leave-to"
								>
									<template v-slot:activator>
										<v-list-item-title :class="(activeMenu.includes(menu.title)) ? 'cl-black font-weight-bold' : ''" :title="menu.title">{{ menu.title }}</v-list-item-title>
									</template>

									<template v-for="(sub, ids) in menu.children">
										<template v-if="sub.children.length > 0">
											<v-list-group
												:value="(activeMenu.includes(sub.title)) ? true : false"
												:key="ids"
												no-action
												sub-group
											>
												<template v-slot:activator>
													<v-list-item-content>
														<v-list-item-title>{{ sub.title }}</v-list-item-title>
													</v-list-item-content>
												</template>

												<v-list-item
													v-for="(sub2, ids2) in sub.children"
													:key="ids2"
													link
													router 
													:to="`${sub2.path}`" 
													@click="setActiveMenu(sub2.path)" 
													color="cl-primary-light" 
													class="no-drop"
													:class="(activeMenu.includes(sub2.title)) ? 'is-activemenu' : ''"
												>
													<v-list-item-title v-text="sub2.title"></v-list-item-title>

													<v-list-item-icon>
														<v-icon v-text="sub2.icon"></v-icon>
													</v-list-item-icon>
												</v-list-item>
											</v-list-group>
										</template>

										<template v-else>
											<v-list-item :key="ids" router :to="`${sub.path}`" @click="setActiveMenu(sub.path)" color="cl-primary-light" class="no-drop" :class="(activeMenu.includes(sub.title)) ? 'is-activemenu' : ''">
												<v-list-item-icon>
													<v-icon>{{ sub.icon }}</v-icon>
												</v-list-item-icon>

												<v-list-item-title>{{ sub.title }}</v-list-item-title>
											</v-list-item>
										</template>
									</template>

								</v-list-group>
							</template>
						</template>
					</v-list>
				</template>
			</v-navigation-drawer>
		</div>

		<Header :isDrawer="navbar" v-on:childToParent="clickDrawer" />

		<v-main class="">
			<v-container fluid class="px-3">
				<v-row align="center" justify="center">
					<v-col class="px-0 px-md-3">
						<v-snackbar v-model="snackbar.show" timeout="4000" right top :color="snackbar.color">
							{{snackbar.text}}
							<template v-slot:action="{ attrs }">
								<v-btn color="white" text v-bind="attrs" @click="hideSnackbar">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</template>
						</v-snackbar>
						<v-snackbar v-model="errorAlert.show" timeout="4000" right top :color="errorAlert.color" class="mt-5">
							<div v-for="(alert, i) in errorAlert.alert" :key="i">{{ alert }}</div>
							<template v-slot:action="{ attrs }">
								<v-btn color="white" text v-bind="attrs" @click="hideAlert">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</template>
						</v-snackbar>
						<router-view />
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Header from '@/components/layout/vo-general/Header';

export default {
	components: {
		Header
	},
	props: {
	},
	computed: {
		...mapState(['snackbar', 'errorAlert']),
		// ...mapState('autentikasi', ['userData']),
	},
	data: () => ({
		drawer: null,
		navbar: 236,
		toggleDrawer: false,
		activeMenu: [],
		dashboardPath: '',
		arrMenu: [],
	}),
	methods: {
		...mapMutations(['hideSnackbar', 'hideAlert']),

		goDashboard() {
			this.$router.push({ name: 'dashboard' })
		},
		setActiveMenu(child) {
			if (child) {
				this.activeMenu = []
				// eslint-disable-next-line no-unused-vars
				this.arrMenu.forEach((menu) => {
					if (menu.path === child) {
						this.activeMenu.push(menu.title)
					} else {
						if (menu.children.length > 0) {
							// eslint-disable-next-line no-unused-vars
							menu.children.forEach((childMenu) => {
								if (childMenu.path === child) {
									this.activeMenu.push(childMenu.title)
									this.activeMenu.push(menu.title)
								} else {
									if (childMenu.children.length > 0) {
										// eslint-disable-next-line no-unused-vars
										childMenu.children.forEach((subChildMenu) => {
											if (subChildMenu.path === child) {
												this.activeMenu.push(subChildMenu.title)
												this.activeMenu.push(childMenu.title)
												this.activeMenu.push(menu.title)
											}
										})
									}
								}
							})
						}
					}
				})
			} else {
				this.activeMenu = []
			}

			// console.log('activeMenu', this.activeMenu)
		},
		clickDrawer() {
			if (window.matchMedia('(min-width: 1264px)').matches) {
				if (this.navbar == 236) {
					this.navbar = 70
				} else {
					this.navbar = 236
				}
			} else {
				this.drawer = !this.drawer
			}
			this.toggleDrawer = false
		},
		showDrawer() {
			if (this.navbar == 70) {
				this.navbar = 236
				this.toggleDrawer = true
			}
		},
		hideDrawer() {
			if (this.toggleDrawer == true) {
				this.navbar = 70
			}
		},
	},
	created() {
		const authData = localStorage.getItem('mlmcore-vo-auth-data');
		const data = JSON.parse(authData);

		let voMenu = [
			{
				title: 'Dashboard',
				path: '/',
				icon: 'mdi-home-outline',
				children: [],
			}, 
			{
				title: 'Ceria',
				path: '',
				icon: 'mdi-database-outline',
				children: [
					{
						title: 'Komisi Ceria',
						path: '',
						icon: 'mdi-database-outline',
						children: [
							{
								title: 'Summary Komisi',
								path: '/summary-komisi-ceria',
								children: [],
							},
							{
								title: 'Riwayat Komisi',
								path: '/riwayat-komisi-ceria',
								children: [],
							},
							{
								title: 'Riwayat Transfer',
								path: '/riwayat-transfer-ceria',
								children: [],
							},
						],
					}, 

					{
						title: 'Jaringan Ceria',
						path: '',
						icon: 'mdi-account-group-outline',
						children: [
							{
								title: 'Genealogy Ceria',
								path: '/genealogy-ceria',
								children: [],
							}, 
							{
								title: 'Sponsor Pribadi Ceria',
								path: '/sponsor-pribadi-ceria',
								children: [],
							}, 
							{
								title: 'Pertumbuhan Jaringan Ceria',
								path: '/pertumbuhan-jaringan-ceria',
								children: [],
							}, 
							{
								title: 'Downline Ceria',
								path: '/downline-ceria',
								children: [],
							}
						]
					},
				]
			},
			{
				title: 'Ekonomis',
				path: '',
				icon: 'mdi-database-outline',
				children: [
					{
						title: 'Komisi Ekonomis',
						path: '',
						icon: 'mdi-database-outline',
						children: [
							{
								title: 'Summary Komisi',
								path: '/summary-komisi-ekonomis',
								children: [],
							},
							{
								title: 'Riwayat Komisi',
								path: '/riwayat-komisi-ekonomis',
								children: [],
							},
							{
								title: 'Riwayat Transfer',
								path: '/riwayat-transfer-ekonomis',
								children: [],
							},
						],
					}, 

					{
						title: 'Jaringan Ekonomis',
						path: '',
						icon: 'mdi-account-group-outline',
						children: [
							// {
							// 	title: 'Registrasi Mitra',
							// 	path: '/registrasi',
							// },
							{
								title: 'Genealogy Ekonomis',
								path: '/genealogy-ekonomis',
								children: [],
							}, 
							{
								title: 'Genealogy RO',
								path: '/genealogy-ekonomis-ro',
								children: [],
							}, 
							{
								title: 'Sponsor Pribadi Ekonomis',
								path: '/sponsor-pribadi-ekonomis',
								children: [],
							}, 
							{
								title: 'Pertumbuhan Jaringan Ekonomis',
								path: '/pertumbuhan-jaringan-ekonomis',
								children: [],
							}, 
							{
								title: 'Downline Ekonomis',
								path: '/downline-ekonomis',
								children: [],
							}
						]
					},

					{
						title: 'Reward Flush Out',
						path: '/list-reward-flush-out',
						icon: 'mdi-medal-outline',
						children: [],
					}, 
					{
						title: 'Reward Royalti Peringkat',
						path: '/list-reward-planb',
						icon: 'mdi-medal-outline',
						children: [],
					}, 
				]
			},
			{
				title: 'Premium',
				path: '',
				icon: 'mdi-database-lock',
				children: [
					{
						title: 'Komisi Premium',
						path: '',
						icon: 'mdi-database-outline',
						children: [
							{
								title: 'Summary Komisi',
								path: '/summary-komisi-premium',
								children: [],
							},
							{
								title: 'Riwayat Komisi',
								path: '/riwayat-komisi-premium',
								children: [],
							},
							{
								title: 'Riwayat Transfer',
								path: '/riwayat-transfer-premium',
								children: [],
							},
						],
					},

					{
						title: 'Jaringan Premium',
						path: '',
						icon: 'mdi-account-group',
						children: [
							// {
							// 	title: 'Registrasi Mitra',
							// 	path: '/registrasi',
							// },
							{
								title: 'Genealogy Premium',
								path: '/genealogy-premium',
								children: [],
							}, 
							{
								title: 'Sponsor Pribadi Premium',
								path: '/sponsor-pribadi-premium',
								children: [],
							}, 
							{
								title: 'Pertumbuhan Jaringan Premium',
								path: '/pertumbuhan-jaringan-premium',
								children: [],
							}, 
							{
								title: 'Downline Premium',
								path: '/downline-premium',
								children: [],
							}
						]
					},

					// {
					// 	title: 'Reward Premium',
					// 	path: '',
					// 	icon: 'mdi-medal',
					// 	children: [
					// 		{
					// 			title: 'Peringkat Saya',
					// 			path: '/peringkat-saya',
					// 			children: [],
					// 		},
					// 		{
					// 			title: 'Reward Saya',
					// 			path: '/reward-saya',
					// 			children: [],
					// 		},
					// 	],
					// }, 

					{
						title: 'Reward Saya',
						path: '/reward-saya',
						icon: 'mdi-medal',
						children: [],
					}, 
				],
			},

			{
				title: 'Supreme',
				path: '',
				icon: 'mdi-database-lock',
				children: [
					{
						title: 'Komisi Supreme',
						path: '',
						icon: 'mdi-database-outline',
						children: [
							{
								title: 'Summary Komisi',
								path: '/summary-komisi-supreme',
								children: [],
							},
							{
								title: 'Riwayat Komisi',
								path: '/riwayat-komisi-supreme',
								children: [],
							},
							{
								title: 'Riwayat Transfer',
								path: '/riwayat-transfer-supreme',
								children: [],
							},
						],
					},

					{
						title: 'Jaringan Supreme',
						path: '',
						icon: 'mdi-account-group',
						children: [
							{
								title: 'Genealogy Supreme',
								path: '/genealogy-supreme',
								children: [],
							}, 
							{
								title: 'Sponsor Pribadi Supreme',
								path: '/sponsor-pribadi-supreme',
								children: [],
							}, 
							{
								title: 'Pertumbuhan Jaringan Supreme',
								path: '/pertumbuhan-jaringan-supreme',
								children: [],
							}, 
							{
								title: 'Downline Supreme',
								path: '/downline-supreme',
								children: [],
							}
						]
					},
				],
			},
			
			
			// {
			// 	title: 'Saldo Anda',
			// 	path: '/',
			// 	icon: 'mdi-wallet-outline',
			// 	children: [
			// 		{
			// 			title: 'Summary Saldo',
			// 			path: '/summary-saldo',
			// 		},
			// 		{
			// 			title: 'Riwayat Transfer',
			// 			path: '/riwayat-transfer',
			// 		},
			// 	],
			// }, 
			
			
			{
				title: 'Daftar Stokis',
				path: '/daftar-stokis',
				icon: 'mdi-store-search-outline',
				children: [],
			}, 
			// {
			// 	title: 'Repeat Order',
			// 	path: '',
			// 	icon: 'mdi-credit-card-sync-outline',
			// 	children: [
			// 		{
			// 			title: 'Input RO',
			// 			path: '/input-ro',
			// 		}, {
			// 			title: 'Riwayat RO',
			// 			path: '/riwayat-ro',
			// 		},
			// 	]
			// }, 
			// {
			// 	title: 'Transaksi Produk',
			// 	path: '',
			// 	icon: 'mdi-cart',
			// 	children: [
			// 		{
			// 			title: 'Beli Produk',
			// 			path: '/beli-produk',
			// 		},
			// 		{
			// 			title: 'Lap. Pembelian Produk',
			// 			path: '/lap-pembelian-produk',
			// 		},
			// 	]
			// },
			{
				title: 'Stok Serial',
				path: '',
				icon: 'mdi-card-bulleted-outline',
				children: [
					{
						title: 'Stok Serial',
						path: '/stok-serial',
						children: [],
					}, {
						title: 'Kirim Serial',
						path: '/kirim-serial',
						children: [],
					}, {
						title: 'Riwayat Kirim Serial',
						path: '/riwayat-kirim-serial',
						children: [],
					}, {
						title: 'Riwayat Transaksi Serial',
						path: '/riwayat-transaksi-serial',
						children: [],
					},
				],
			}, 
			{
				title: 'Laporan Pajak',
				path: '/pajak',
				icon: 'mdi-percent-box-outline',
				children: [],
			},
			
			// {
			// 	title: 'Reward Flush Out',
			// 	path: '',
			// 	icon: 'mdi-medal-outline',
			// 	children: [
			// 		{
			// 			title: 'List Reward',
			// 			path: '/list-reward-flush-out',
			// 		},
			// 		{
			// 			title: 'Riwayat Reward',
			// 			path: '/reward-flush-out-saya',
			// 		},
			// 	],
			// }, 
			// {
			// 	title: 'Reward Plan B',
			// 	path: '',
			// 	icon: 'mdi-medal-outline',
			// 	children: [
			// 		{
			// 			title: 'List Reward',
			// 			path: '/list-reward-planb',
			// 		},
			// 		{
			// 			title: 'Riwayat Reward',
			// 			path: '/reward-planb-saya',
			// 		},
			// 	],
			// }, 

			{
				title: 'Peringkat Saya',
				path: '/peringkat-saya',
				icon: 'mdi-medal',
				children: [],
			}, 
			{
				title: 'Web Replika',
				path: '/web-replika',
				icon: 'mdi-web',
				children: [],
			}, 
			{
				title: 'Pengumuman',
				path: '/pengumuman',
				icon: 'mdi-bullhorn-variant-outline',
				children: [],
			}, 
			{
				title: 'Testimoni',
				path: '/testimoni',
				icon: 'mdi-format-float-left',
				children: [],
			}, 
			// {
			// 	title: 'Pesan',
			// 	path: '/',
			// 	icon: 'mdi-email-outline',
			// 	children: [
			// 		{
			// 			title: 'Buat Pesan',
			// 			path: '/buat-pesan',
			// 		},
			// 		{
			// 			title: 'Pesan Masuk',
			// 			path: '/pesan-masuk',
			// 		},
			// 		{
			// 			title: 'Pesan Terkirim',
			// 			path: '/pesan-terkirim',
			// 		},
			// 	],
			// },
		]
		if (data.member_is_stockist === "1" || data.member_is_stockist == "1") {
			// let pengajuanStokisMenu = [
			// 	{
			// 		title: 'Pengajuan Stokis',
			// 		path: '/pengajuan-stokis',
			// 		icon: 'mdi-account-check-outline',
			// 		children: [],
			// 	}
			// ]
			// pengajuanStokisMenu.forEach((el) => {
			// 	// voMenu.push(el)
			// 	voMenu.splice(7, 0, el)
			// })
			let stokisAreaMenu = {
			title: 'Stokis & Mastok Area',
				path: '',
				icon: 'mdi-storefront-outline',
				children: [
					{
						title: 'Belanja Produk',
						path: '/belanja-produk',
						children: [],
					},
					{
						title: 'Lap. Belanja Produk',
						path: '/lap-belanja-produk',
						children: [],
					},
					// {
					// 	title: 'Lap. Penjualan',
					// 	path: '/lap-penjualan',
					// },
					{
						title: 'Stok Serial Stokis',
						path: '/stok-serial-stokis',
						children: [],
					},
					{
						title: 'Kirim Serial Stokis',
						path: '/kirim-serial-stokis',
						children: [],
					},
					{
						title: 'Riwayat Serial Stokis',
						path: '/riwayat-serial-stokis',
						children: [],
					},
				],
			}
			voMenu.splice(5, 0, stokisAreaMenu)
		}
		// if (data.member_network_type_id === "1" || data.member_network_type_id == "1") {
		// 	let upgradeJaringanMenu = {
		// 	title: 'Upgrade Jaringan',
		// 		path: '/upgrade',
		// 		icon: 'mdi-account-arrow-up-outline',
		// 		children: [],
		// 	}
		// 	voMenu.splice(5, 0, upgradeJaringanMenu)
		// }
		voMenu.forEach((el) => {
			this.arrMenu.push(el)
		})
		this.setActiveMenu(this.$route.path)
	}
};
</script>

<style lang="scss" scoped>
	.cus-m-navbar {
		padding: 0 5px;
	}

	.maxicon {
			display: block;
		}
		.minicon {
			display: none;
			padding: 5px;
			margin-top: -5px;
		}

	.nav--isCollapsed {
		.maxicon {
			display: none;
		}
		.minicon {
			display: block
		}
	}

	@media (max-width: 767.98px) {
		.cus-m-navbar {
			height: calc(100vh - 0%)!important;
		}
  }
</style>